/*
  Client-side mirror of the server's submission limits (server.py).
  One constant so the gallery cap, alerts, and labels can't drift apart -
  if you change it, change MAX_PHOTOS_PER_SUBMISSION on the server too.
*/
export const MAX_PHOTOS = 10;
